import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Dropdown } from '@hivebrite/design-system/Dropdown';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import ThemeProvider from 'hb-react/style/ThemeProvider';

const LanguagePicker = ({
  curentLocale,
  headerSocialColor,
  locales,
  primaryColor,
}) => {
  const languages = useMemo(
    () =>
      locales.map((locale) => ({
        code: locale,
        label: I18n.t(`locales.${locale}`),
      })),
    [locales],
  );

  const handleClickItem = useCallback((item) => {
    Cookies.set('hivebrite', JSON.stringify({ locale: item.code }), {
      expires: 30,
      path: '/',
      secure: window.__HB_ENV__.ENVIRONMENT === 'production',
    });

    window.location.reload();
  }, []);

  return (
    <ThemeProvider
      theme="po"
      options={{
        customNetworkColors: { button_primary: primaryColor },
      }}
    >
      <BrowserRouter>
        <Dropdown items={languages} onClickItem={handleClickItem}>
          {({ isOpen }) => (
            <Box ml={5}>
              <Box color={headerSocialColor} alignItems="center">
                <FontAwesomeIcon height="16px" iconName="globe" />
              </Box>
              <Box
                color={headerSocialColor}
                alignItems="center"
                ml={2}
                font="h4-regular"
              >
                {curentLocale?.toUpperCase() || __('Language')}
              </Box>
              <Box color={headerSocialColor} ml={2} alignItems="flex-end">
                {isOpen ? (
                  <FontAwesomeIcon
                    height="16px"
                    iconName="angle-up"
                    iconType={CATEGORIES.LIGHT}
                  />
                ) : (
                  <FontAwesomeIcon
                    height="16px"
                    iconName="angle-down"
                    iconType={CATEGORIES.LIGHT}
                  />
                )}
              </Box>
            </Box>
          )}
        </Dropdown>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default LanguagePicker;
